import { UNORDERED_LIST } from '../constants';
import type { UnorderedListElement } from '../types';

/** Create an unordered list element */
export const createUnorderedList = (children: UnorderedListElement['children']): UnorderedListElement => {
    return { type: UNORDERED_LIST, children };
};
